// extracted by mini-css-extract-plugin
export default {"wrapper":"RecommendedFood_wrapper__kUFCp","img":"RecommendedFood_img__OwSo5","title":"RecommendedFood_title__fYY4T","content":"RecommendedFood_content__oXNzW"};